
import { locale } from './globals.js';

class ProfileBrowser {
  constructor(el) {
    if(!el) return false;
    this.el = el;
    this.rtl = (locale.dir == 'rtl')
    this.hashes = []
    this.slides = Array.from(this.el.querySelectorAll('.swiper-slide'))
    this.initContents()
    this.createSlider()
    this.slider.init()
    this.el.setAttribute('data-state', 'ready')
    window.addEventListener('hashchange', (event) => {
      this.checkHash()
    })
  }
  initContents() {
    this.slides.forEach((slide) => {
      this.hashes.push(slide.getAttribute("data-hash"))
    })
    this.contents = Array.from(this.el.querySelectorAll('[data-profile-content]'))
    
    let hash = (location.hash) ? location.hash.slice(1) : this.hashes[0];
    this.contents.forEach((content) => {
      content.classList.add('tab-content')
      if (content.getAttribute('data-profile-content') == hash) {
        content.classList.add('active')
      } else {
        content.classList.remove('active')
      }
    })
  }
  checkHash () {
    let hash = location.hash.slice(1)
    this.contents.forEach((content) => {
      if (content.getAttribute('data-profile-content') == hash) {
        content.classList.add('active')
      } else {
        content.classList.remove('active')
      }
    })
  }
  createSlider () {
    let options = {
      hashNavigation: { watchState: true },
      centeredSlides: true,
      slidesPerView: 'auto',
      speed: 400,
      loop: false,
      navigation: {
        nextEl: '[data-slider-next]',
        prevEl: '[data-slider-prev]'
      },
      init: false
    }
    this.slider = new Swiper(this.el.querySelector('[data-slider]'), options)
    
    let externalPrevBtn = this.el.querySelector('[data-slider-prev="external"]')
    let externalNextBtn = this.el.querySelector('[data-slider-next="external"]')
    if (externalPrevBtn) externalPrevBtn.addEventListener('click', () => this.slider.slidePrev())
    if (externalNextBtn) externalNextBtn.addEventListener('click', () => this.slider.slideNext())
    this.slider.on('slideChange', updateExternalNav.bind(this))
    function updateExternalNav() {
      if (this.slider.isBeginning) externalPrevBtn.setAttribute('disabled', 'disabled')
      else externalPrevBtn.removeAttribute('disabled')

      if (this.slider.isEnd) externalNextBtn.setAttribute('disabled', 'disabled')
      else externalNextBtn.removeAttribute('disabled')
    }
    this.slides.forEach((slide, index) => {
      slide.setAttribute('data-index', index)
      slide.addEventListener('click', () => {
        this.slideClickHandler(slide)
      })
    })
  }
  slideClickHandler(slide) {
    this.slider.slideTo(slide.getAttribute('data-index'))
  }
}

function init () {
  document.querySelectorAll('[data-profile-browser]').forEach(elem => {
    if(!elem.hasAttribute('data-state')) new ProfileBrowser(elem)
  })
}
document.body.addEventListener('domupdated', () => init())
init()